import moment from 'moment';
import { Nav } from 'react-bootstrap';
import { RiArrowLeftSLine, RiArrowRightSLine } from 'react-icons/ri';
import { getWeekDayAbbreviation, getWeekDayFullName } from '../../utils/dateUtils';
import { DateSwitcherTimeslotCol, DateSwitcherTimeslotColStartEnd } from '../Cols/StyledCol';
import { IPhysicianSelectionCardWithDateSwitcher } from '../PhysicianSelectionCard/PhysicianSelectionCardWithDateSwitcher';
import { DateSwitcherRow } from '../Rows/StyledRow';
import MyTooltip from '../Tooltip/MyTooltip';
import { ReactElement } from 'react';
import { useLanguage } from '../../hooks/useLanguage';

type IHorizontalDateSwitcher = IPhysicianSelectionCardWithDateSwitcher;

const HorizontalDateSwitcher = (props: IHorizontalDateSwitcher) => {
    const { t } = useLanguage();

    const showDate = (date: Date, offset: number) => {
        const momentDate = moment(date).add(offset, 'days');
        const weekdayAbbr = getWeekDayAbbreviation(momentDate);
        const weekdayFull = getWeekDayFullName(momentDate);

        // TODO-discuss: might as well be aria-hidden, as it is out of place for non-sighted people.
        return (
            <div aria-label={`${weekdayFull}, ${momentDate.format('Do MMMM')}`} style={{ textAlign: 'center' }}>
                <div aria-hidden style={{ fontWeight: 'bold' }}>
                    {weekdayAbbr}
                </div>
                <div aria-hidden>{momentDate.format('DD.MM.')}</div>
            </div>
        );
    };

    const dates = () => {
        return Array.from({ length: props.countDaysToVisualize }).map((_, index) => (
            <DateSwitcherTimeslotCol key={index}>{showDate(props.startDate, index)}</DateSwitcherTimeslotCol>
        ));
    };

    return (
        <DateSwitcherRow>
            <DateSwitcherTimeslotColStartEnd>
                <Nav.Link
                    aria-label={t('BUTTONS', 'Frühere Termine')}
                    style={{ padding: '0px' }}
                    disabled={false}
                    onClick={() => props.handlePreviousDate()}
                >
                    <MyTooltip
                        id="goBackTooltip"
                        text={t('BUTTONS', 'Frühere Termine')}
                        iconDiv={true}
                        divWidth="30px"
                        marginLeft="auto"
                        marginRight="0"
                        icon={<RiArrowLeftSLine size={30} />}
                    ></MyTooltip>
                </Nav.Link>
            </DateSwitcherTimeslotColStartEnd>
            {dates()}
            <DateSwitcherTimeslotColStartEnd>
                <Nav.Item>
                    <Nav.Link
                        aria-label={t('BUTTONS', 'Spätere Termine')}
                        style={{ padding: '0px' }}
                        disabled={false}
                        onClick={() => props.handleNextDate()}
                    >
                        <MyTooltip
                            id="goForwardTooltip"
                            text={t('BUTTONS', 'Spätere Termine')}
                            iconDiv={true}
                            divWidth="30px"
                            marginLeft="0"
                            marginRight="auto"
                            icon={<RiArrowRightSLine size={30} />}
                        ></MyTooltip>
                    </Nav.Link>
                </Nav.Item>
            </DateSwitcherTimeslotColStartEnd>
        </DateSwitcherRow>
    );
};

export default HorizontalDateSwitcher;
